module.exports = __webpack_public_path__ + "static/media/Ft_Macon_History_Museum_diorama_detail_beach_side_installed_acrylic_on_canvas_2010.3925b9ad.webp";